export default {
  segments: null,
  segmentsDownloads: null,
  unsubscribeAllSegmentsDownloads: null,
  segmentsAutomations: null,
  unsubscribeAllSegmentsAutomations: null,
};
